// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var CustomReport$ReactHooksTemplate = require("./CustomReport.res.js");

function CustomReportForm(props) {
  var handleCustomReportChange = props.handleCustomReportChange;
  var organizationCustomReports = props.organizationCustomReports;
  var template = props.template;
  React.useEffect((function (param) {
          var match = CustomReport$ReactHooksTemplate.reportLogicId(template);
          var match$1 = Belt_List.length(organizationCustomReports);
          if (match !== undefined || match$1 !== 1) {
            
          } else {
            Belt_Option.map(Belt_List.head(organizationCustomReports), (function (report) {
                    Curry._2(handleCustomReportChange, template, String(report.id));
                  }));
          }
        }), []);
  var id = CustomReport$ReactHooksTemplate.reportLogicId(template);
  var tmp;
  if (id !== undefined) {
    tmp = String(id);
  } else {
    var customReportId = String(Belt_Option.getExn(Belt_Option.map(Belt_List.head(organizationCustomReports), (function (report) {
                    return report.id;
                  }))));
    Curry._2(handleCustomReportChange, template, customReportId);
    tmp = customReportId;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("div", {
                                  children: "Custom Report Fields",
                                  className: "text-sm font-bold"
                                }),
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mb-20-px items-center"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Report Type",
                                    className: "text-sm font-medium w-1/5"
                                  }),
                              JsxRuntime.jsxs("select", {
                                    children: [
                                      JsxRuntime.jsx("option", {
                                            children: "Select Report Type",
                                            disabled: true,
                                            value: "Select Report Type"
                                          }, "0"),
                                      $$Array.of_list(Belt_List.map(organizationCustomReports, (function (report) {
                                                  return JsxRuntime.jsx("option", {
                                                              children: report.name,
                                                              value: String(report.id)
                                                            }, String(report.id));
                                                })))
                                    ],
                                    className: "block border px-3 py-2 border-gray-400\n                        w-3/5 bg-white rounded capitalize mr-6 text-sm",
                                    placeholder: "Select Report Type",
                                    value: tmp,
                                    onChange: (function ($$event) {
                                        Curry._2(handleCustomReportChange, template, Utils$ReactHooksTemplate.formTargetValue($$event));
                                      })
                                  })
                            ],
                            className: "flex gap-1 items-center w-full"
                          }),
                      className: "flex mb-30-px items-center"
                    })
              ]
            });
}

var make = CustomReportForm;

exports.make = make;
/* react Not a pure module */
